import { ChatService } from '../chat.service';
import { Thread, ChatMessage } from '../models';
import { Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'region-thread',
    styles: [require('./region-thread.component.scss')],
    template: require('./region-thread.component.pug')
})
export class RegionThreadComponent implements OnInit {
    @Input() thread: Thread;
    hasMessage: Boolean = false;
    message: ChatMessage;

    constructor(private _chatService: ChatService) {
    }

    ngOnInit() {
        if (this.thread.messages.length > 0) {
            this.hasMessage = true;
        };

        if (this.hasMessage) {
            this.message = this.thread.messages[this.thread.messages.length - 1];
        }
    }

    open(thread: Thread) {
       this._chatService.pushChatCommand({id: 'openThread', data: thread});
       this.message = null;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/region-thread/region-thread.component.ts